import { createFileRoute } from "@tanstack/react-router"
import { ArrowLeft } from "lucide-react"
import { UploadDetails } from "@/components/project/UploadStatus/UploadDetails"

export const Route = createFileRoute("/_private/projects/$id/data/uploads")({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  return (
    <div className="flex flex-col">
      <button
        onClick={() => history.back()}
        className="text-muted-foreground mb-4 mt-2 flex items-center gap-1 text-sm focus-visible:outline-0"
      >
        <ArrowLeft size={12} />
        <span>Back</span>
      </button>

      <UploadDetails projectId={id} />
    </div>
  )
}
